import { createAction } from '@reduxjs/toolkit';

export const clearSignupErrors = createAction('la/ui/createAccount/clearSignupErrors');
